<template>
  <v-form ref="areaEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'delivery-index', params: {tab: 0}})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ area.id ? 'Редактировать район' : 'Создать район'}}</h1>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col class="pb-0 mb-0">
                <v-text-field
                        v-model="area.name"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col class="pb-0 mb-0">
                <v-text-field
                        v-model="area.name_ua"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-dialog
                ref="timeDialog"
                v-model="timeModal"
                :return-value.sync="area.default_delivery_time"
                width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                    v-model="area.default_delivery_time"
                    label="Время доставки"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
            ></v-text-field>
          </template>
          <v-time-picker
                  v-model="area.default_delivery_time"
                  full-width
                  format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn
                    text
                    color="primary"
                    @click="timeModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                    text
                    color="primary"
                    @click="$refs.timeDialog.save(area.default_delivery_time  )"
            >
              OK
            </v-btn>
          </v-time-picker>
        </v-dialog>
          <v-text-field
                  v-model="area.min_sum"
                  label="Минимальная сумма доставки"
                  suffix="UAH"
                  :rules="[rules.required]"
                  required
                  outlined
          ></v-text-field>
        <v-select
                :items="branches"
                :item-text="branch => branch.name"
                :item-value="branch => branch"
                v-model="area.branch"
                :rules="[rules.requiredSelect]"
                required
                label="Филиал"
                outlined
        ></v-select>

        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import AreaService from './../../../api/AreaService'
  import BranchService from "../../../api/BranchService";
  import moment from 'moment'

  export default {
    name: 'AreaEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      timeModal: false,
      tabLang: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: v => {return !!v.id || 'Нужно заполнить'},
      },
      valid: true,
      area: {
          name: '',
          name_ua: '',
          branch: {},
          min_sum: '',
          default_delivery_time: '00:00',
          delivery_time: null

      },
      loading: true,
      loadingButton: false,
      branches: [],
    }),
    mounted() {
        this.init()
      BranchService.list().then(response => {
        this.branches = response.data
      });
    },
    methods: {
      validate () {
        this.$refs.areaEditForm.validate()
        if(this.area.name == '' && this.area.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.area.name != '' && this.area.name_ua == ''){
          this.tabLang = 1;
        }
      },
      init(){
        if(this.id) {
          AreaService.get(this.id)
            .then(response => {
              this.area = response.data;
              this.loading = false
            });
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        let formData = this.getData();

        AreaService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Район успешно обновлен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении района';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
          this.loadingButton = true;
          var formData = this.getData();

          AreaService.create(formData).then(response => {
            this.snackbar = true;
            this.snackbarText = 'Район успешно создан';
            this.snackbarColor = 'success';
            this.$router.push({ name: 'area-edit', params: { id: response.data.id } })
            this.init();
          }).catch(error => {
            this.snackbar = true;
            this.snackbarText = 'Ошибка при создании района';
            this.snackbarColor = 'error';
          }).finally(() => {
            this.loadingButton = false
          })
      },
      getData() {
          let formData = new FormData();
          let time = moment('2020-01-01 ' + this.area.default_delivery_time).format('HH:mm:ss')

          formData.append('id', this.id);
          formData.append('name', this.area.name);
          formData.append('name_ua', this.area.name_ua);
          formData.append('min_sum', this.area.min_sum);
          formData.append('default_delivery_time', time);
          formData.append('delivery_time', this.area.delivery_time ? this.area.delivery_time : time);
          formData.append('branch_id', this.area.branch ? this.area.branch.id : null);

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .area-images .v-image{
    max-height: 374px;
  }
  .area{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
